// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PriorityCell-base__qTY71{display:flex;align-items:center;width:var(--size-full);height:var(--size-12);padding:var(--size-0) var(--size-4);border-bottom:var(--size-px) solid var(--gray-a3);font:var(--font-body-400-compact);font-feature-settings:var(--feature-settings-body-400-compact);letter-spacing:var(--letter-spacing-body-400-compact)}.PriorityCell-primary__o0mvq{color:var(--text-strong)}.PriorityCell-warning__RY6xj{color:var(--orange-9)}.PriorityCell-content__lhmbT{display:flex;flex-direction:row;gap:var(--size-1);align-items:center;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "PriorityCell-base__qTY71",
	"primary": "PriorityCell-primary__o0mvq",
	"warning": "PriorityCell-warning__RY6xj",
	"content": "PriorityCell-content__lhmbT"
};
export default ___CSS_LOADER_EXPORT___;
